<template lang="pug">
#app(style="position: relative")
  subscribe
  .container-fluid.top-menu
    .row
      .col-lg-3.col-xs-3
        .ers-branding
          a.ers-branding__logo(@click="navigate('/')")
            img(src='/logo.svg')
      .col-lg-6.hidden-md-down
        .text-center(v-if="page === 'constituency'")
          h2(style="padding: 0")
            i.fa.fa-map-marked-alt
          h2(style="padding: 0") {{selectedConstituencyName}}
        .region-selector.text-center(v-if="page !== 'constituency'"
          @mouseleave="currentlyHoveredRegion = null")
          div
            .region-option(
              @click="navigate(`/`)"
              @mouseenter="currentlyHoveredRegion = 'uk'"
              v-bind:class=`{
                hover: currentlyHoveredRegion === 'uk',
                selected: page === ''
              }`) UK
            .region-option(v-for="(regionName, regionEscaped) in regionSelector"
              @click="navigate(`/region/${regionEscaped}`)"
              :data-type="regionEscaped"
              v-bind:class=`{
                hover: currentlyHoveredRegion === regionEscaped ||
                  (page === 'region' && regionEscaped === 'england' && !regionSelector[pageParam]),
                selected: page === 'region' && pageParam === regionEscaped
              }`
              @mouseenter="currentlyHoveredRegion = regionEscaped") {{getPlaceName(regionName)}}
          .eng-sub-region-options(v-if=`currentlyHoveredRegion === 'england'
            || (page === 'region' && !regionSelector[pageParam])
            `)
            .region-option-sub(v-for="(regionName, regionEscaped) in englandSubRegionSelector"
              @click="navigate(`/region/${regionEscaped}`)"
              v-bind:class=`{ selected: page === 'region' && pageParam === regionEscaped}`) {{getPlaceName(regionName)}}
      .col-lg-3.col-xs-9
        constituency-finder(v-if="page !== 'constituency'")
        //-div(v-if="page !== 'constituency'")
          #postcode-finder-hint Would you like to see the results for your constituency?
            |  Type your postcode below:
          input#postcode-finder(type='text'
            placeholder='E.g. N1 0EN'
            v-model='postcode'
            @keyup.enter="findConstituencyByPostcode")
          button.btn.btn-primary(
            style="width: 70px !important;margin-bottom: 16px;"
            @click='findConstituencyByPostcode'
            :disabled='postcodeInSearch') Find
          .postcode-error.text-danger(v-if='postcodeError') Postcode not found
        .text-right(v-if="page === 'constituency'")
          a(@click="navigate(`/region/${selectedConstituencyRegionNameEscaped}`)")
            i.fa.fa-chart-area
            |  See results for
            strong  {{selectedConstituencyRegionName}}
  .top-menu-marginer
  .countdown(v-if="!electionStarted && countdown")
    .gap-40
    .container-fluid.text-center
      .row
        .col-lg-3
        .col-lg-6
          h2 Welcome to the Electoral Reform Society’s 2019 general election results hub.
          p As soon as results start being declared, from around 11pm on Thursday 12 December, we will keep you up to date with all the latest developments.
            br
            | Voting closes in:
      .row
        .col-lg-4
        .col-lg-1
          h1(style="padding: 0") {{countdown.days}}
          div days
        .col-lg-1
          h1(style="padding: 0") {{countdown.hours}}
          div hours
        .col-lg-1
          h1(style="padding: 0") {{countdown.minutes}}
          div minutes
        .col-lg-1
          h1(style="padding: 0") {{countdown.seconds}}
          div seconds
  template(v-if="electionStarted")
    template(v-if="dataLoaded")
      template(v-if="page === 'constituency'")
        .container-fluid
          .row.hidden-lg-up.text-center
            h2(style="padding: 0;padding-top: 20px;")
              i.fa.fa-map-marked-alt
            h2(style="padding: 0") {{selectedConstituencyName}}
      .container-fluid(v-if="!this.data.constituencies.length")
        .row
          .col-lg-3
          .col-lg-6.text-center
            .gap-40
            h2 Welcome to the Electoral Reform Society’s 2019 general election results hub.
            p Voting in the 2019 General Election is now closed! As soon as results start being declared, around 11pm, we will keep you up to date with all the latest developments. You will also be able to explore the outcome in your constituency, wider nation or region and across the UK as a whole.
      template(v-if="this.data.constituencies.length")
        template(v-if="page === 'constituency'")
          .container-fluid
            .row.text-center
              .col-lg-12
                .gap-40
                h3 Winning party
              .col-lg-12
                .party-winner(
                  :data-party="selectedConstituencyWinningParty.name"
                  :style="{ 'background-color': selectedConstituencyWinningParty.colour }")
                  .party-winner-name {{selectedConstituencyWinningParty.name}}
                  div(v-if="selectedConstituency.$.gainOrHold === 'hold'")
                    i.fa.fa-hand-rock
                    |  Hold
                  div(v-else)
                    i.fa.fa-trophy
                    |  Gain
                    span(v-if="selectedConstituencyPreviouslyWinningParty")  from {{selectedConstituencyPreviouslyWinningParty.name}}
              .col-lg-12
                | Candidate elected:
                strong
                  |  {{selectedConstituency.Candidate[0].$.firstName}}
                  |  {{selectedConstituency.Candidate[0].$.surname}}
              .col-lg-12
                | Majority:
                strong  {{selectedConstituency.$.majority | commas}}
                br
                br
            .row
              .col-lg-12
                h2 2019 General Election Results
                b-table(
                  bordered
                  :fields="partiesTableFields"
                  :items="partiesTableItems")
                  template(v-slot:cell(name)="data")
                    span(v-html="data.value")
                  template(v-slot:cell(totalVotes)="data")
                    span {{data.value | commas}}
                  template(v-slot:cell(totalVotesShareChange)="data")
                    span(v-html="forcePlusSign(data.value)")
                  template(v-slot:cell(totalVotesShare)="data")
                    span {{oneDecimal(data.value)}}
          .gap-40
          sign-petition
          .gap-40
          .container-fluid
            .row.text-center
              .col-lg-4
                h1(style="padding: 0 0 20px 0") {{turnoutPercentage}}%
                strong Turnout
              .col-lg-4
                h1.with-sup(style="padding: 0 0 20px 0") {{constituencyRankForWinningMargin}}
                  .sup {{nth(constituencyRankForWinningMargin)}}
                strong Smallest Margin of Victory
              .col-lg-4
                h1.with-sup(style="padding: 0 0 20px 0") {{constituencyRankForPercentNeededToWin}}
                  .sup {{nth(constituencyRankForPercentNeededToWin)}}
                strong Smallest Share of the Vote Needed to Win
          .gap-40
          .text-muted.text-center Seats declared: {{fullData.constituencies.length}} out of 650
        template(v-if="page !== 'constituency'")
          .container-fluid.non-constituency-page
            .row
              .col-lg-8
                h1(style="padding-top: 0")
                  template(v-if="page !== 'region'") 2019 General Election Results
                  template(v-else) 2019 General Election in {{getPlaceName(selectedRegionName, true)}}
                div
                  .custom-badge(:style="{ 'background-color': othersColor, opacity: 0.6 }")
                  | % Votes
                  .text-gap
                  .custom-badge(:style="{ 'background-color': othersColor }")
                  | % Seats
                g-chart(type='ColumnChart'
                  :data='partiesChartData'
                  :options=`{
                    legend: { position: 'none' },
                    height: 400,
                    chartArea: {
                      width: '100%',
                      left: 20,
                      top: 60,
                      bottom: 40,
                      height: '100%'
                    }
                  }`)
                seats-declared
              .col-lg-4
                table.table.table-bordered.table-condensed(v-if="data.constituencies.length < data.constituenciesTotal")
                  tr
                    th Latest results
                    th
                  tr(v-for='constituency in this.data.latestResults'
                    :key='`constituency-${constituency.name}`')
                    td
                      a(:href="`/constituency/${constituency.nameEscaped}`"
                        @click.prevent="navigate(`/constituency/${constituency.nameEscaped}`)") {{constituency.name}}
                    //- td
                      .custom-badge(:style="{ 'background-color': constituency.winningPartyColour }")
                      | {{constituency.winningPartyName}}
                    td {{constituency.ago}}
                table.table.table-bordered.parties-stats-table.table-condensed
                  tr
                    th Party
                    th.parties-stats-table-seats Seats
                  tr(v-for='party in this.data.parties'
                    :key='`party-${party.name}`')
                    td
                      .custom-badge(:style="{ 'background-color': party.colour }")
                      | {{party.name}}
                    td {{party.totalSeats}}
                seats-declared
          .gap-40
          magic-buttons(:backendHost="backendHost" :page="$route.path" :frontendHost="frontendHost")
          .gap-40
          .container-fluid
            .row
              .col-lg-7
                h2 Top 10: Smallest Margin of Victory
                table.table.table-bordered.parties-stats-table.table-condensed
                  tr
                    th Constituency
                    th.column-minimum-margin Margin (votes)
                    th Winning party
                    th 2nd placed party
                  tr(v-for='constituency in this.data.top10ConstituenciesSmallestMarginOfWinning'
                    :key='`constituency-${constituency.name}`')
                    td
                      a(:href="`/constituency/${constituency.nameEscaped}`"
                        @click.prevent="navigate(`/constituency/${constituency.nameEscaped}`)") {{constituency.name}}
                    td {{constituency.smallestMarginOfWinning | commas}}
                    td
                      .custom-badge(:style="{ 'background-color': constituency.winningPartyColour }")
                      | {{constituency.winningPartyName === 'Labour and Co-operative' ? 'Labour' : constituency.winningPartyName}}
                      span(v-if="constituency.winningPartyName === 'Independent'")
                        |  {{constituency.winningPartyCandidateName}}
                    td
                      .custom-badge(:style="{ 'background-color': constituency.secondPlacePartyColour }")
                      | {{constituency.secondPlacePartyName === 'Labour and Co-operative' ? 'Labour' : constituency.secondPlacePartyName}}
                      span(v-if="constituency.secondPlacePartyName === 'Independent'")
                        |  {{constituency.secondPlacePartyCandidateName}}
                seats-declared
                .gap-40
                h2 Top 10: Smallest Share of the Vote Needed to Win
                table.table.table-bordered.parties-stats-table.table-condensed
                  tr
                    th Constituency
                    th.column-needed-to-win Vote share (%)
                    th Winning party
                  tr(v-for='constituency in this.data.top10ConstituenciesSmallestVotesShareNeededToWin'
                    :key='`constituency-${constituency.name}`')
                    td
                      a(:href="`/constituency/${constituency.nameEscaped}`"
                        @click.prevent="navigate(`/constituency/${constituency.nameEscaped}`)") {{constituency.name}}
                    td {{constituency.winningPartyVotesShare}}
                    td
                      .custom-badge(:style="{ 'background-color': constituency.winningPartyColour }")
                      | {{constituency.winningPartyName === 'Labour and Co-operative' ? 'Labour' : constituency.winningPartyName}}
                      span(v-if="constituency.winningPartyName === 'Independent'")
                        |  {{constituency.winningPartyCandidateName}}
                seats-declared
              .col-lg-5
                .gap-40
                .gap-40.hidden-xs-down
                hex-map(:region="pageParam")
          .gap-40
          sign-petition
          .gap-40
          .container-fluid
            .row
              .col-lg-4
                h2 Percentage change since 2017
                div
                  .custom-badge(:style="{ 'background-color': othersColor, opacity: 0.6 }")
                  | % Votes change
                  .text-gap
                  .custom-badge(:style="{ 'background-color': othersColor }")
                  | % Seats change
                g-chart(type='BarChart'
                  :data="seatsVsVotesChangeChartData"
                  :options=`{
                    legend: { position: 'none' },
                    height: 400,
                    hAxis: {
                      viewWindow: {
                        min: -20,
                        max: 20,
                      },
                    },
                    chartArea: {
                      width: '100%',
                      left: 80,
                      top: 20,
                      height: '100%',
                    }
                  }`)
                seats-declared(style="margin-bottom: 40px")
              .col-lg-8
                h2 Full Results
                b-table.table-condensed.parties-table(
                  :fields="partiesTableFields"
                  :items="partiesExtendedTableItems")
                  template(v-slot:cell(name)="data")
                    span(v-html="data.value")
                  template(v-slot:cell(totalVotes)="data")
                    span {{data.value | commas}}
                  template(v-slot:cell(totalVotesPerSeat)="data")
                    span {{data.value | commas}}
                  template(v-slot:cell(totalVotesShare)="data")
                    span(v-if="!oneDecimal(data.value)")
                      span(style="font-family: Arial") &lt;
                      span  0.1
                    span(v-else) {{oneDecimal(data.value)}}
                  template(v-slot:cell(totalSeatsShare)="data")
                    span {{oneDecimal(data.value)}}
                seats-declared
            .row
              div(:class="{ 'col-lg-3': page === '', 'col-lg-12': page !== '' }")
                br
                h2 Turnout in
                  template(v-if="page !== 'region'")  the UK
                  template(v-else)  {{getPlaceName(selectedRegionName, true)}}
                  template(v-if="data.constituencies.length < data.constituenciesTotal")  so far
                div {{data.totalVotes | commas}}
                h1(style="padding-top: 0") {{turnoutPercentage}}%
              .col-lg-9(v-if="page === ''")
                br
                div
                  .custom-badge(:style="{ 'background-color': othersColor }")
                  | % Turnout
                g-chart(type='LineChart'
                  :data='turnoutHistoryChartData'
                  :options=`{
                    legend: { position: 'none' },
                    height: 400,
                    chartArea: {
                      width: '100%',
                      left: 35,
                      top: 20,
                      bottom: 40,
                      height: '100%',
                    },
                  }`)
                seats-declared
  .gap-40
  magic-buttons(:backendHost="backendHost" :page="$route.path" :frontendHost="frontendHost")
  join-newsletter
  .divider
  .container-fluid.non-constituency-page
    .row
      .col-md-6
        h2 About us
        p The Electoral Reform Society is an independent campaigning organisation working to champion the rights of voters and build a better democracy in Great Britain and Northern Ireland.
          a(href="https://www.electoral-reform.org.uk/who-we-are" target="_blank" style="margin-left: 10px") Learn more
      .col-md-1
      .col-md-5
        footer#colophon.ers-site-footer(role='contentinfo')
          section.ers-site-footer__site-info
            ul#menu-footer-bottom.link-list.link-list--dark.link-list--horizontal.link-list--underline
              li.menu-item.menu-item-type-post_type.menu-item-object-page
                a(href='https://www.electoral-reform.org.uk/accessibility/') Accessibility
              li.menu-item.menu-item-type-post_type.menu-item-object-page
                a(href='https://www.electoral-reform.org.uk/privacy-and-cookies/') Privacy &amp; Cookies
              li.menu-item.menu-item-type-post_type.menu-item-object-page
                a(href='https://www.electoral-reform.org.uk/who-we-are/contact-us/') Contact us
            .ers-site-footer__satellite
              p
                | A company limited by guarantee. registered in London, no. 958404. All content &copy; 2019 Electoral Reform Society
  .gap-40.hidden-xs-down
</template>

<script>
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import {
  map,
  orderBy,
  values,
  pick,
  forEach,
} from 'lodash';
import { GChart } from 'vue-google-charts';
// import VueSocketIO from 'vue-socket.io'
import moment from 'moment'
import SignPetition from './components/SignPetition.vue'
import MagicButtons from './components/MagicButtons.vue'
import JoinNewsletter from './components/JoinNewsletter.vue'
import HexMap from './components/HexMap.vue'
import SeatsDeclared from './components/SeatsDeclared.vue'
import Subscribe from './components/Subscribe.vue'
import ConstituencyFinder from './components/ConstituencyFinder.vue'

const axios = require('axios');

const BACKEND_HOST = `${location.protocol}//${location.hostname}`;
const FRONTEND_HOST = `${BACKEND_HOST}${location.port ? `:${location.port}` : ''}`;

Vue.use(BootstrapVue)
// Vue.use(new VueSocketIO({ connection: BACKEND_HOST }))

export default {
  watch: {
    $route(to, from) {
      if (Object.keys(from.query).length) return

      this.recalculateData()
      this.scrollToTop()
    }
  },
  /*
  sockets: {
    updatesPublished() {
      this.loadAndProcessData()
    }
  },
  */
  data() {
    return {
      subscribePopupOpened: false,
      electionStarted: false,
      countdown: null,
      seatsVsVotesChangeInterval: null,
      frontendHost: FRONTEND_HOST,
      backendHost: BACKEND_HOST,
      othersColor: '#A6A6A6',
      // The data that we get from server
      fullData: {
        constituencies: [],
      },
      // Filtered data
      data: {
        constituencies: [],
        constituenciesIndexedByNumber: {},
        parties: [],
        partiesExtended: [],
        totalVotes: 0,
        totalSeats: 0,
        totalSeatsPrev: 0,
        totalVotesPrev: 0,
        wastedVotes: 0,
      },
      staticData: {
        constituenciesNumbersToPcon18cdMap: {},
        partiesAbbreviationsToColours: {},
        electionStartsIn: null,
      },
      dataLoaded: null,
      postcode: '',
      postcodeError: false,
      postcodeInSearch: false,
      page: '',
      pageTitle: '',
      selectedConstituency: {},
      selectedConstituencyWinningParty: {},
      selectedConstituencyName: '',
      selectedRegionName: '',
      selectedConstituencyRegionName: '',
      selectedConstituencyRegionNameEscaped: '',
      currentlyHoveredRegion: '',
    };
  },
  components: {
    GChart,
    SignPetition,
    MagicButtons,
    JoinNewsletter,
    HexMap,
    SeatsDeclared,
    Subscribe,
    ConstituencyFinder,
  },
  name: 'App',
  methods: {
    async init() {
      if (location.search) {
        this.$router.replace(`${location.pathname.replace(/\/$/, '')}`)
      }

      await this.loadStaticData()
      this.electionStartsOn = moment(this.staticData.electionStarts)
        .format('MMMM Do')
      this.electionStartsAt = moment(this.staticData.electionStarts)
        .format('HH:mm')
      this.updateElectionStarted();

      if (!this.electionStarted) {
        this.launchCountdown()
      }

      await this.loadAndProcessData()

      this.dataLoaded = true;
    },
    launchCountdown() {
      this.countdownInterval = setInterval(() => {
        this.updateElectionStarted();

        if (this.electionStarted) {
          clearInterval(this.countdownInterval)
        }
      }, 1000)
    },
    updateElectionStarted() {
      const diff = moment(this.staticData.electionStarts).diff(moment())
      const electionStartsIn = moment.duration(diff)

      this.electionStarted = diff < 0
      this.countdown = {
        days: electionStartsIn.days(),
        hours: electionStartsIn.hours(),
        minutes: electionStartsIn.minutes(),
        seconds: electionStartsIn.seconds(),
      }
    },
    async loadAndProcessData() {
      await this.loadData()

      this.processFullAndStaticData()
      this.recalculateData()
    },
    recalculateData() {
      this.processData();
    },
    async loadData() {
      return axios.get(`${BACKEND_HOST}/data`)
        .then((results) => {
          this.fullData = results.data
        });
    },
    async loadStaticData() {
      return axios.get(`${BACKEND_HOST}/static-data`)
        .then((results) => {
          this.staticData = results.data;
        });
    },
    partyColourByAbbr(partyAbbr) {
      const partyColour = this.staticData.partiesAbbreviationsToColours[partyAbbr];

      return partyColour || this.othersColor;
    },
    processFullAndStaticData() {
      this.fullData.constituenciesIndexedByNumber = {}
      this.fullData.constituencies.forEach((constituency, index) => {
        const number = constituency.data.Election[0].Constituency[0].$.number

        this.fullData.constituenciesIndexedByNumber[number] = index
      })
    },
    processData() {
      const currentPathPieces = this.$route.path.split('/')

      this.fullData.electorate = 0
      this.data.electorate = 0
      this.page = currentPathPieces[1]
      this.pageParam = this.page !== ''
        ? currentPathPieces[2].toLowerCase() : ''
      this.data.constituencies = this.fullData.constituencies

      this.data.constituencies.forEach(constituency => {
        const constituencyData = constituency.data.Election[0].Constituency[0].$

        constituencyData.region =
          this.staticData.constituenciesNumbersToRegions[constituencyData.number]
        constituencyData.regionEscaped = this.escapeString(constituencyData.region)
        constituencyData.nameEscaped = this.escapeString(constituencyData.name)
      })

      if (this.page === 'constituency') {
        this.data.constituencies = this.data.constituencies.filter(constituency => (
          constituency.data.Election[0].Constituency[0].$.nameEscaped ===
            this.pageParam
        ))

        this.selectedConstituencyName =
          values(this.staticData.constituenciesPcon18ToNames)
            .find(constituencyName => this.escapeString(constituencyName) === this.pageParam)

        const constituenciesEscapedNameToPcons = {}

        forEach(this.staticData.constituenciesPcon18ToNames, (name, pcon) => {
          constituenciesEscapedNameToPcons[this.escapeString(name)] = pcon
        })

        this.selectedConstituencyRegionName = this.staticData.constituenciesNumbersToRegions[
          this.staticData.constituenciesPcon18ToNumbers[
            constituenciesEscapedNameToPcons[this.pageParam]
          ]
        ]
        this.selectedConstituencyRegionNameEscaped = this.escapeString(
          this.selectedConstituencyRegionName
        )

        if (!this.data.constituencies[0]) {
          return
        }

        this.selectedConstituency =
          this.data.constituencies[0].data.Election[0].Constituency[0]

        this.selectedConstituencyPreviousResults =
          this.data.constituencies[0].data.PreviousElection[0].Constituency[0]
      }

      if (this.page === 'region') {
        const lookupBy = this.pageParam !== 'england'
          ? [this.pageParam] : Object.keys(this.englandSubRegionSelector)

        this.data.constituencies = this.data.constituencies.filter(constituency => (
          lookupBy.indexOf(constituency.data.Election[0].Constituency[0].$.regionEscaped) !== -1
        ))
        this.selectedRegionName =
          this.pageParam !== 'england'
            ? values(this.staticData.constituenciesNumbersToRegions)
              .find(regionName => this.escapeString(regionName) === this.pageParam) : 'England'
        this.data.constituenciesTotal = values(this.staticData.constituenciesNumbersToRegions)
          .filter(regionName => lookupBy.indexOf(this.escapeString(regionName)) !== -1).length
      } else {
        this.data.constituenciesTotal = 650
      }

      this.data.constituenciesIndexedByNumber = {}
      this.data.constituencies.forEach((constituency, index) => {
        const number = constituency.data.Election[0].Constituency[0].$.number

        this.data.constituenciesIndexedByNumber[number] = index
        this.fullData.electorate += parseInt(constituency.data.Election[0].Constituency[0].$.electorate, 10)
      })

      const parties = {}
      let wastedVotes = 0

      this.data.constituencies.forEach(constituency => {
        constituency.data.Election[0].Constituency[0].Candidate.forEach(candidate => {
          const partyData = candidate.Party[0].$
          const partyAbbr = partyData.abbreviation
          const partyName = partyAbbr === 'Lab Co-op' ? 'Labour' : partyData.name
          const partyNameProcessed = partyAbbr === 'Lab Co-op' ? 'Labour' : this.fixPartyName(partyName)

          if (!parties[partyName]) {
            parties[partyName] = {
              colour: this.partyColourByAbbr(partyAbbr),
              name: partyNameProcessed,
              // @NOTE valid only for Constituency results
              candidate: `${candidate.$.firstName} ${candidate.$.surname}`,
              abbreviation: partyAbbr,
              totalSeats: 0,
              totalVotes: 0,
              totalSeatsPrev: 0,
              totalVotesPrev: 0,
            }
          }

          if (candidate.$.elected) {
            parties[partyName].totalSeats += 1
          } else {
            wastedVotes += parseFloat(partyData.votes)
          }

          parties[partyName].totalVotes += parseFloat(partyData.votes)
        })
      })

      // Calculating total votes/seats
      this.data.totalVotes = 0
      this.data.totalSeats = 0
      this.data.totalVotesPrev = 0
      this.data.totalSeatsPrev = 0

      this.data.constituencies.forEach(constituency => {
        this.data.totalVotesPrev += parseInt(constituency.data.PreviousElection[0].Constituency[0].$.turnout, 10)

        constituency.data.PreviousElection[0].Constituency[0].Candidate.forEach((candidate, candidateIndex) => {
          const partyData = candidate.Party[0].$
          const partyAbbr = partyData.abbreviation
          const partyName = partyAbbr === 'Lab Co-op' ? 'Labour' : partyData.name

          if (!parties[partyName]) {
            return
          }

          if (candidateIndex === 0) {
            parties[partyName].totalSeatsPrev += 1
          }

          parties[partyName].totalVotesPrev += parseFloat(partyData.votes)
        })
      })

      this.data.wastedVotes = wastedVotes
      this.data.parties = values(parties)

      this.data.parties.forEach(party => {
        this.data.totalVotes += party.totalVotes
        this.data.totalSeats += party.totalSeats
      })

      this.data.totalSeatsPrev = this.data.constituencies.length

      // Sorting by seats
      this.data.parties = orderBy(this.data.parties, ['totalSeats'], ['desc'])

      if (this.page !== 'constituency') {
        this.condenseParties('extendedParties', 'partiesExtended')
        this.condenseParties('mainParties', 'parties')
      }

      // Assigning calculated numbers to parties
      this.calculatePartiesData('parties')
      this.calculatePartiesData('partiesExtended')

      this.fullData.constituencies.forEach(constituency => {
        const electionConstituency = constituency.data.Election[0].Constituency[0]

        // Calculating smallest margin of winning per each constituency
        electionConstituency.$.smallestMarginOfWinning =
          electionConstituency.Candidate[0].Party[0].$.votes -
          electionConstituency.Candidate[1].Party[0].$.votes
      })

      this.data.constituencies.forEach(constituency => {
        this.data.electorate += parseInt(constituency.data.Election[0].Constituency[0].$.electorate, 10)
      })

      // Setting a winning party
      if (this.page === 'constituency') {
        this.selectedConstituencyWinningParty = this.data.parties.filter(party => {
          const partyAbbr = this.selectedConstituency.Candidate[0].Party[0].$.abbreviation

          if (party.abbreviation === 'Lab Co-op') {
            return partyAbbr === 'Lab' || partyAbbr === 'Lab Co-op'
          }

          return party.abbreviation === partyAbbr
        })[0]
        this.selectedConstituencyPreviouslyWinningParty = this.data.parties.filter(party => {
          const partyAbbr = this.selectedConstituencyPreviousResults.Candidate[0].Party[0].$.abbreviation

          if (party.abbreviation === 'Lab Co-op') {
            return partyAbbr === 'Lab' || partyAbbr === 'Lab Co-op'
          }

          return party.abbreviation === partyAbbr
        })[0]
      }

      // Caching smallest margin of winning top 10 constituencies
      this.data.top10ConstituenciesSmallestMarginOfWinning =
        orderBy(this.data.constituencies.map(constituency => {
          const electionConstituency = constituency.data.Election[0].Constituency[0]
          const electionConstituencyData = electionConstituency.$

          return {
            name: electionConstituencyData.name,
            nameEscaped: electionConstituencyData.nameEscaped,
            smallestMarginOfWinning: electionConstituencyData.smallestMarginOfWinning,
            winningParty: electionConstituencyData.winningParty,
            winningPartyName: this.fixPartyName(electionConstituency.Candidate[0].Party[0].$.name),
            winningPartyCandidateName: this.getCandidateName(electionConstituency.Candidate[0].$),
            secondPlaceParty: electionConstituency.Candidate[1].Party[0].$.abbreviation,
            secondPlacePartyCandidateName: this.getCandidateName(electionConstituency.Candidate[1].$),
            winningPartyColour:
              this.partyColourByAbbr(electionConstituencyData.winningParty),
            secondPlacePartyColour:
              this.partyColourByAbbr(electionConstituency.Candidate[1].Party[0].$.abbreviation),
            secondPlacePartyName: this.fixPartyName(electionConstituency.Candidate[1].Party[0].$.name)
          }
        }), ['smallestMarginOfWinning'], ['asc']).slice(0, 10)

      // Caching top 10 constituencies by smallets votes needed to win
      this.data.top10ConstituenciesSmallestVotesShareNeededToWin =
        orderBy(this.data.constituencies.map(constituency => {
          const electionConstituency = constituency.data.Election[0].Constituency[0]
          const electionConstituencyData = electionConstituency.$

          return {
            name: electionConstituencyData.name,
            nameEscaped: electionConstituencyData.nameEscaped,
            winningPartyVotesShare: this.oneDecimal(electionConstituency.Candidate[0].Party[0].$.percentageShare),
            winningParty: electionConstituencyData.winningParty,
            winningPartyColour:
              this.partyColourByAbbr(electionConstituencyData.winningParty),
            winningPartyName: this.fixPartyName(electionConstituency.Candidate[0].Party[0].$.name),
            winningPartyCandidateName: this.getCandidateName(electionConstituency.Candidate[0].$),
          }
        }), ['winningPartyVotesShare'], ['asc']).slice(0, 10)

      // Latest results
      this.data.latestResults =
        orderBy(this.data.constituencies.map(constituency => {
          const electionConstituency = constituency.data.Election[0].Constituency[0]
          const electionConstituencyData = electionConstituency.$

          return {
            createdAt: constituency.createdAt,
            nameEscaped: electionConstituencyData.nameEscaped,
            name: electionConstituencyData.name,
            winningPartyColour:
              this.partyColourByAbbr(electionConstituencyData.winningParty),
            winningPartyName: electionConstituency.Candidate[0].Party[0].$.name,
            ago: moment(constituency.createdAt).fromNow()
          }
        }), ['createdAt'], ['desc']).slice(0, 5)
    },
    getCandidateName(candidateProps) {
      return `${candidateProps.firstName} ${candidateProps.surname}`
    },
    findConstituencyByPostcode() {
      this.postcodeInSearch = true

      axios.get(`https://api.postcodes.io/postcodes/${this.postcode}`)
        .then(results => {
          const constituencyPcon18cd = results.data.result.codes.parliamentary_constituency
          const constituencyName =
            this.staticData.constituenciesPcon18ToNames[constituencyPcon18cd]
          const constituencyNameEscaped = this.escapeString(constituencyName)

          this.navigate(`/constituency/${constituencyNameEscaped}`)
        })
        .catch(() => {
          this.postcodeError = true

          setTimeout(() => {
            this.postcodeError = false
          }, 2000)
        })
        .finally(() => {
          this.postcodeInSearch = false
        })
    },
    calculatePartiesData(resourceParties) {
      this.data[resourceParties].forEach(party => {
        party.totalSeatsShare = this.percentage(party.totalSeats / this.data.totalSeats)
        party.totalVotesShare = this.percentage(party.totalVotes / this.data.totalVotes)
        party.totalSeatsSharePrev = this.percentage(party.totalSeatsPrev / this.data.totalSeatsPrev)
        party.totalVotesSharePrev = this.percentage(party.totalVotesPrev / this.data.totalVotesPrev)
        party.totalSeatsShareChange = this.oneDecimal(party.totalSeatsShare - party.totalSeatsSharePrev)
        party.totalVotesShareChange = this.oneDecimal(party.totalVotesShare - party.totalVotesSharePrev)
        party.totalVotesPerSeat = party.totalSeats > 0
          ? Math.floor(party.totalVotes / party.totalSeats) : 'n/a'
      })
    },
    condenseParties(resourceParties, destination) {
      const condensedParties = [];
      const otherParties = {
        abbreviation: 'Others',
        name: 'Others',
        colour: this.othersColor,
        totalSeats: 0,
        totalVotes: 0,
      };
      const partiesList = this.page === 'region' && this.pageParam === 'northern_ireland'
        ? this.staticData.niParties : this.staticData[resourceParties]

      this.data.parties.forEach(party => {
        if (partiesList.indexOf(party.abbreviation) > -1) {
          condensedParties.push(party);

          return;
        }

        otherParties.totalSeats += party.totalSeats
        otherParties.totalVotes += party.totalVotes
      })
      condensedParties.push(otherParties)

      this.data[destination] = condensedParties
    },
    fixPartyName(partyName) {
      if (partyName === 'No description') {
        return ''
      }

      if (partyName.match(/^independent/i)) {
        return 'Independent'
      }

      if (partyName === 'Green') {
        return 'Green Party'
      }

      if (partyName === 'Sinn Fein') {
        return 'Sinn Féin'
      }

      return partyName
    },
    navigate(path) {
      this.$router.push(path)
    },
    getPlaceName(place, withThe) {
      if (place === 'Eastern') {
        return `${withThe ? 'the ' : ''}East of England`
      }

      if (withThe && [
        'South East',
        'West Midlands',
        'North West',
        'East Midlands',
        'South West',
        'North East'].indexOf(place) !== -1) {
        return `the ${place}`
      }

      return place
    },
    highlightConstituencyInMap(event) {
      const object = event.propagatedFrom
      const pcon16cd = object.feature.properties.pcon16cd
      const constituencyNumber =
        this.staticData.constituenciesPcon18ToNumbers[pcon16cd];
      const constituency = this.data.constituencies[
        this.data.constituenciesIndexedByNumber[constituencyNumber]
      ]

      if (!constituency) {
        return
      }

      const name = constituency.data.Election[0].Constituency[0].$.name

      object.bindPopup(name)
      object.openPopup()
      object.setStyle({
        fillOpacity: 0.7
      })
    },
    unhighlightConstituencyInMap(event) {
      const object = event.propagatedFrom

      object.closePopup()
      event.propagatedFrom.setStyle({
        fillOpacity: 1
      })
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    },
    escapeString(string) {
      return string.toLowerCase().replace(/\s/g, '_')
    },
    getSelectedConstituencyRankBy(field) {
      return orderBy(this.fullData.constituencies, field)
        .findIndex(
          constituency => constituency.data.Election[0].Constituency[0].$.nameEscaped ===
            this.selectedConstituency.$.nameEscaped
        ) + 1
    },
    forcePlusSign(number) {
      const stringNum = number.toString().replace(/-/, '')

      if (number < 0) {
        return `<span class='text-danger'><strong>-</strong> ${stringNum}</span>`
      }

      return `<span class='text-success'><strong>+</strong> ${stringNum}</span>`
    },
    nth(number) {
      const lastDigit = number % 10
      const lastTwoDigits = number % 100
      const isTeen = lastTwoDigits >= 10 && lastTwoDigits < 20

      if (isTeen) {
        return 'th'
      }

      if (lastDigit === 1) {
        return 'st'
      }

      if (lastDigit === 2) {
        return 'nd'
      }

      if (lastDigit === 3) {
        return 'rd'
      }

      return 'th'
    },
    percentage(number) {
      return number * 100
    },
    oneDecimal(number) {
      return Math.round(number * 10) / 10
    },
  },
  filters: {
    commas(number) {
      const parts = number.toString().split('.')

      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      return parts.join('.');
    },
  },
  computed: {
    turnoutPercentage() {
      return this.oneDecimal(this.percentage(this.data.totalVotes / this.data.electorate))
    },
    seatsVsVotesChangeChartData() {
      if (!this.dataLoaded) return [];
      const table = [['Party', 'Votes % Change', { role: 'style' }, 'Seats % Change', { role: 'style' }]];

      this.data.parties.forEach(party => {
        if (party.name === 'Others') return

        table.push([
          party.name,
          party.totalVotesShareChange,
          `color: ${party.colour}; opacity: 0.6; stroke-width: 0`,
          party.totalSeatsShareChange,
          `color: ${party.colour}; stroke-width: 0`,
        ])
      })

      return table;
    },
    partiesChartData() {
      if (!this.dataLoaded) return [];
      const table = [['Party', 'Votes %', { role: 'style' }, 'Seats %', { role: 'style' }]];

      this.data.parties.forEach(party => {
        table.push([
          party.name,
          this.oneDecimal(party.totalVotesShare),
          `color: ${party.colour}; opacity: 0.6; stroke-width: 0`,
          this.oneDecimal(party.totalSeatsShare),
          `color: ${party.colour}; stroke-width: 0`,
        ])
      })

      return table;
    },
    turnoutHistoryChartData() {
      if (!this.dataLoaded) return [];

      const turnoutHistory = { ...this.staticData.turnoutHistory }

      turnoutHistory[2019] = this.turnoutPercentage

      const table = [['Year', 'Turnout', { role: 'style' }]];
      const turnoutHistoryOrdered =
        orderBy(
          map(turnoutHistory, (totalTurnout, year) => ({
            year: year.toString(),
            totalTurnout: parseFloat(totalTurnout),
          })),
          ['year']
        );

      turnoutHistoryOrdered.forEach(entry => {
        table.push([
          entry.year,
          entry.totalTurnout,
          `color: ${this.othersColor}`,
        ])
      })

      return table;
    },
    wastedVotes() {
      return this.percentage(this.data.wastedVotes / this.data.totalVotes)
    },
    partiesTableColumns() {
      return this.page !== 'constituency'
        ? [
          'name',
          'totalSeats',
          'totalSeatsShare',
          'totalVotesShare',
          'totalVotes',
          'totalVotesPerSeat',
        ] : [
          'name',
          'candidate',
          'totalVotes',
          'totalVotesShare',
          'totalVotesShareChange',
        ]
    },
    partiesTableFields() {
      const columnsToLabels = {
        name: 'Party',
        totalSeats: 'Seats',
        totalSeatsShare: 'Seats %',
        totalVotesShare: 'Votes %',
        totalVotes: 'Votes',
        totalVotesPerSeat: 'Votes per Seat',
        totalVotesShareChange: 'Votes % Change'
      }

      return this.partiesTableColumns.map(column => ({
        key: column,
        label: columnsToLabels[column],
        sortable: column !== 'name'
      }))
    },
    partiesTableItems() {
      return this.data.parties.map(party => ({
        ...pick(party, this.partiesTableColumns),
        name: `<div class="custom-badge" style="background-color: ${party.colour}"></div>${party.name}`,
      }))
    },
    partiesExtendedTableItems() {
      return this.data.partiesExtended.map(party => ({
        ...pick(party, this.partiesTableColumns),
        name: `<div class="custom-badge" style="background-color: ${party.colour}"></div>${party.name}`,
      }))
    },
    constituencyRankForWinningMargin() {
      if (this.page !== 'constituency') return 0

      return this.getSelectedConstituencyRankBy(
        'data.Election[0].Constituency[0].$.smallestMarginOfWinning'
      )
    },
    constituencyRankForPercentNeededToWin() {
      if (this.page !== 'constituency') return 0

      return this.getSelectedConstituencyRankBy(
        'data.Election[0].Constituency[0].Candidate[0].Party[0].$.percentageShare'
      )
    },
    regionSelector() {
      return {
        wales: 'Wales',
        scotland: 'Scotland',
        england: 'England',
        northern_ireland: 'Northern Ireland',
      }
    },
    englandSubRegionSelector() {
      return {
        london: 'London',
        south_east: 'South East',
        west_midlands: 'West Midlands',
        north_west: 'North West',
        east_midlands: 'East Midlands',
        eastern: 'Eastern',
        south_west: 'South West',
        north_east: 'North East',
        yorkshire_and_the_humber: 'Yorkshire and The Humber',
      }
    }
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss">
  // @NOTE these cannopt be included, they break the design...
  // @import 'node_modules/bootstrap/scss/bootstrap';
  // @import 'node_modules/bootstrap-vue/src/index.scss';
  // @NOTE Bootstrap grid is provided by the original ERS theme
  @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.11.2/css/all.min.css');

  body {
    font-family: 'Din Regular';
  }

  p {
    font-family: 'Crimson Text';
  }

  a {
    cursor: pointer;

    &:hover {
      opacity: 0.8
    }
  }

  .custom-badge {
    display: inline-block;
    height: 1em;
    width: 1em;
    border-radius: 2px;
    margin-bottom: -0.1em;
    margin-right: 10px;
  }

  .text-gap {
    display: inline-block;
    margin-left: 20px;
  }

  #postcode-finder {
    max-width: 130px;
    height: 50px;
    margin-right: 10px;
  }

  [id*='google-visualization-errors-all'] {
    display: none !important;
  }

  table {
    min-width: auto;
  }

  .gap-40 {
    height: 40px;
  }

  .container-cta {
    padding: 40px 0;

    &.light-cta {
      background-color: transparent;
    }

    &.dark-cta {
      background-color: #313b52;

      &, h1, h2 {
        color: white;
      }
    }
  }

  .divider {
    border-bottom: solid 1px #ccc;
  }

  .party-winner {
    &:not([data-party="Scottish National Party"]) {
      color: white;
    }

    display: inline-block;
    padding: 20px 40px;
    border-radius: 7px;
    margin-bottom: 20px;

    .party-winner-name {
      font-size: 100px;
      line-height: 1em;

      @media only screen and (max-width: 600px) {
        font-size: 40px;
      }
    }
  }

  th {
    background-color: #313b52 !important;
  }

  th {
    background-position: right calc(0.75rem / 2) center;
    background-repeat: no-repeat;
    background-size: 0.65em 1em;

    &[aria-sort="ascending"] {
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='white' d='M51 1l25 23 24 22H1l25-22z'/%3e%3cpath fill='white' opacity='.3' d='M51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e")
    }

    &[aria-sort="descending"] {
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='white' opacity='.3' d='M51 1l25 23 24 22H1l25-22z'/%3e%3cpath fill='white' d='M51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e")
    }

    &[aria-sort="none"] {
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='white' opacity='.3' d='M51 1l25 23 24 22H1l25-22zM51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e")
    }
  }

  .region-option {
    display: inline-block;
    cursor: pointer;
    padding: 5px 10px;
    border-radius: 2px;
    border: solid 1px transparent;
    margin: 0 1px;

    &[data-type="england"] {
      border-radius: 2px 2px 0 0;

      &.hover {
        border-bottom: solid 1px white;
      }
    }

    &.hover {
      border: solid 1px #9e589d;
    }

    &.selected {
      font-weight: bold;
      color: #9e589d;
    }
  }

  .eng-sub-region-options {
    max-width: 410px;
    margin: 0 auto;
    padding: 2px 5px 8px 5px;
    border: solid 1px #9e589d;
    border-radius: 2px;
    margin-top: -1px;
  }

  .region-option-sub {
    display: inline-block;
    font-size: 12px;
    line-height: 12px;
    margin-right: 3px;
    border-radius: 2px;
    padding: 0 5px;
    height: 12px;
    text-decoration: underline;
    cursor: pointer;

    &:hover {
      text-decoration: none;
    }

    &.selected {
      font-weight: bold;
      color: #9e589d;
      text-decoration: none;
    }
  }

  .non-constituency-page {
    margin-top: 40px;
  }

  .region-selector {
    margin-top: -11px;
  }

  #postcode-finder-hint {
    font-size: 12px;
    line-height: 12px;
    margin-bottom: 5px;
  }

  .parties-stats-table-seats {
    width: 70px;
  }

  .column-minimum-margin {
    width: 80px;
  }

  .column-needed-to-win {
    width: 110px;
  }

  .huge {
    font-size: 600%;
  }

  .top-menu {
    border-bottom: solid 1px #ccc;
    position: fixed;
    background-color: white;
    z-index: 20000;
    width: 100%;
    padding-top: 30px;
    max-width: 100%;
  }

  .top-menu-marginer {
    height: 130px;
  }

  td {
    border-bottom: solid 1px #ccc;
  }

  th {
    &:first-child {
      border-radius: 3px 0 0 3px;
    }
    &:last-child {
      border-radius: 0 3px 3px 0;
    }
  }

  .parties-table {
    tr {
      td:not(:first-child) {
        white-space: nowrap;
      }
    }
  }

  h1.with-sup {
    margin-top: -0.17em;

    .sup {
      display: inline;
      font-size: 0.5em;
      vertical-align: super;
    }
  }

  .btn {
    margin: 0;
  }

  .postcode-error {
    position: absolute;
    margin-top: -19px;
    font-size: 70%;
  }
</style>
